export default __webpack_public_path__ + "static/media/img_pst_tier_silver.0a2d8bc4.svg";